export default {
  path: '/product_type_file_types',
  name: 'product_type_file_types',
  component: () => import('../components/producttypefiletype/Layout'),
  redirect: { name: 'ProducttypefiletypeList' },
  meta: {
    breadcrumb: 'qualitycheck.product.producttypefiletypes',
  },
  children: [
    {
      name: 'ProducttypefiletypeList',
      path: '',
      component: () => import('../views/producttypefiletype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProducttypefiletypeCreate',
      path: 'new',
      component: () => import('../views/producttypefiletype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProducttypefiletypeUpdate',
      path: ':id/edit',
      component: () => import('../views/producttypefiletype/Update'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiletype',
      },
    },
    {
      name: 'ProducttypefiletypeShow',
      path: ':id',
      component: () => import('../views/producttypefiletype/Show'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiletype',
      },
    }
  ]
};
